import { useCallback } from 'react';

import { useAuthedUser } from '../../common/providers/AuthedUserProvider';
import { requestBuilder } from '../../http/RequestBuilder';

const getUserHasPendingJobs = requestBuilder.query<boolean>({
    endpoint: () => '/api/holistic-bills/pending-jobs',
    queryKey: () => 'getPendingJobs',
});

export const useGetUserHasPendingJobs = (usePolling?: boolean) => {
    const user = useAuthedUser();

    const { data, isLoading, isStale, refetch } = getUserHasPendingJobs(
        {},
        {
            enabled: user?.id !== undefined,
            staleTime: 1000 * 60 * 2,
            refetchInterval: usePolling ? 100000 : false,
            refetchIntervalInBackground: usePolling,
        },
    );

    const refetchUserHasPendingJobs = useCallback(() => {
        if (!isLoading && isStale) {
            void refetch();
        }
    }, [refetch, isLoading, isStale]);

    return {
        userHasPendingJobs: data,
        isLoadingUserHasPendingJobs: isLoading,
        refetchUserHasPendingJobs,
    };
};
